/* ====================================================================
   EPOCH Popup · FIRSTORDER — controller
   - Subscribe via Klaviyo Client API (no API key needed; public endpoint)
   - Gate site-wide "10% off" badges via body.ephoc-subscribed
   - Shows the FIRSTORDER code so the shopper can enter it at checkout
     (the code is NOT auto-applied — removed Sep 13 2026, owner request)
   - Subscribed users: popup never shows
   - Non-subscribed users: popup shows on every visit until they sub or close
     (close is per-visit only — comes back next session)
   ==================================================================== */
(function () {
  'use strict';

  /* ---------- cookie utils ---------- */
  function getCookie(name) {
    var v = '; ' + document.cookie;
    var parts = v.split('; ' + name + '=');
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  }
  function setCookie(name, val, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 86400000);
    document.cookie = name + '=' + val + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  }
  function deleteCookie(name) {
    document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;SameSite=Lax';
  }

  /* ---------- subscribed-state flag ---------- */
  function isSubscribed() {
    try {
      if (getCookie('epoch_w10') === '1') return true;
      if (localStorage.getItem('epoch_w10') === '1') return true;
    } catch (e) {}
    return false;
  }

  /* ---------- dismissed-state flag (24h cooldown after close) ---------- */
  function isDismissed() {
    try {
      if (getCookie('epoch_w10_dismissed') === '1') return true;
    } catch (e) {}
    return false;
  }
  function markDismissed() {
    // 1-day cookie + sessionStorage so this tab session doesn't see it again.
    try {
      setCookie('epoch_w10_dismissed', '1', 1);
      sessionStorage.setItem('epoch_w10_dismissed', '1');
    } catch (e) {}
  }

  function markSubscribed(days) {
    try {
      setCookie('epoch_w10', '1', days || 365);
      localStorage.setItem('epoch_w10', '1');
      localStorage.setItem('epoch_w10_at', String(Date.now()));
    } catch (e) {}
    document.body.classList.add('ephoc-subscribed');
  }

  /* ---------- one-time WELCOME5 cleanup ----
     Older cookies/storage from the WELCOME5 auto-apply mechanism could keep
     the old discount silently applied at the Shopify cart level. When this
     script first runs FOR A NON-SUBSCRIBED VISITOR, force-clear the WELCOME5
     discount via the cart API so they see the real (un-discounted) price.
  */
  function clearShopifyDiscount() {
    // Use Cart Ajax API to clear discount even on empty cart.
    try {
      fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: '' }),
      }).catch(function () {});
    } catch (e) {}
  }
  function cleanupLegacy() {
    try {
      if (sessionStorage.getItem('epoch_w10_cleanup_done')) return;
      sessionStorage.removeItem('ephoc_w5');
      localStorage.removeItem('ephoc_w5');
      // Only force-clear Shopify discount for NON-subscribed users.
      if (!isSubscribed()) {
        clearShopifyDiscount();
      }
      sessionStorage.setItem('epoch_w10_cleanup_done', '1');
    } catch (e) {}
  }

  /* ---------- early body-class application (no flash for subscribed UI) ---- */
  function applyEarlyBodyClass() {
    if (document.body && isSubscribed()) {
      document.body.classList.add('ephoc-subscribed');
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyEarlyBodyClass);
  } else {
    applyEarlyBodyClass();
  }

  /* ---------- no auto-apply ----------
     The discount is a plain code the shopper types at checkout (or in the cart
     drawer's discount field). Nothing here touches /discount/<code>.
  */

  /* ---------- Klaviyo Client API subscribe ----------
     POST /client/subscriptions?company_id=...
     Headers: revision: 2024-10-15
     202 = accepted (also for duplicates).
  */
  function klaviyoSubscribe(opts) {
    var url = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(opts.company);
    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'EPOCH Popup · FIRSTORDER',
          profile: {
            data: {
              type: 'profile',
              attributes: { email: opts.email },
            },
          },
        },
        relationships: {
          list: { data: { type: 'list', id: opts.listId } },
        },
      },
    };
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        revision: '2024-10-15',
        accept: 'application/json',
      },
      body: JSON.stringify(body),
    }).then(function (r) {
      // 202 = accepted; 200 OK is fine too; Klaviyo treats duplicates as 202.
      if (r.status >= 200 && r.status < 300) return { ok: true };
      return r.text().then(function (t) { return { ok: false, status: r.status, body: t }; });
    });
  }

  /* ---------- email validation (RFC-ish, good enough) ---------- */
  function validEmail(e) {
    if (!e) return false;
    e = String(e).trim();
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e) && e.length <= 254;
  }

  /* ---------- popup controller ---------- */
  function initPopup() {
    var pop = document.getElementById('ephoc-w10-popup');
    if (!pop) return;

    // Subscribed users never see the popup.
    if (isSubscribed()) return;
    // Dismissed users get a 24h cooldown before popup returns.
    if (isDismissed()) return;

    var card = document.getElementById('ephoc-w10-card');
    var form = document.getElementById('ephoc-w10-form');
    var input = form ? form.querySelector('input[type="email"]') : null;
    var submit = document.getElementById('ephoc-w10-submit');
    var errorEl = document.getElementById('ephoc-w10-error');
    var successEl = document.getElementById('ephoc-w10-success');

    var company = pop.dataset.company || 'SaagQZ';
    var listId = pop.dataset.list || 'X4QTnN';
    var code = pop.dataset.code || 'FIRSTORDER';
    var pct = parseFloat(pop.dataset.pct || '10');
    var delay = parseInt(pop.dataset.delay || '2800', 10);
    var cookieDays = parseInt(pop.dataset.cookieDays || '365', 10);
    // Product the visitor was looking at when the popup showed (only set on a PDP).
    // Carried into the Klaviyo event so the subscriber-recovery bot can feature THEIR watch.
    var viewedHandle = pop.dataset.productHandle || '';
    var viewedTitle = pop.dataset.productTitle || '';
    var viewedVariant = pop.dataset.variantId || '';
    var viewedImage = pop.dataset.productImage || '';

    var opened = false;
    function open() {
      if (opened) return;
      opened = true;
      pop.classList.add('is-open');
      pop.setAttribute('aria-hidden', 'false');
      fitOneLineText();
    }
    function close(opts) {
      pop.classList.remove('is-open');
      pop.setAttribute('aria-hidden', 'true');
      // Skip cooldown only when called from the success path (subscribed already).
      if (!opts || !opts.skipDismiss) markDismissed();
    }

    // Wire close buttons
    pop.querySelectorAll('[data-w10-close]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        close();
      });
    });
    // Escape closes
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && pop.classList.contains('is-open')) close();
    });
    // Click outside card closes
    pop.addEventListener('click', function (e) {
      if (e.target === pop) close();
    });

    // Slideshow
    var slides = pop.querySelectorAll('.ephoc-w10__slide');
    if (slides.length >= 2) {
      var i = 0;
      setInterval(function () {
        slides[i].classList.remove('is-active');
        i = (i + 1) % slides.length;
        slides[i].classList.add('is-active');
      }, 2400);
    }

    // Submit
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (errorEl) {
          errorEl.classList.remove('is-visible');
          errorEl.textContent = '';
        }
        if (input) input.classList.remove('is-error');
        var email = input ? input.value.trim() : '';
        if (!validEmail(email)) {
          if (input) input.classList.add('is-error');
          if (errorEl) {
            errorEl.textContent = 'Please enter a valid email address.';
            errorEl.classList.add('is-visible');
          }
          return;
        }
        if (submit) {
          submit.disabled = true;
          var span = submit.querySelector('span');
          if (span) {
            submit.dataset.label = span.innerHTML;
            span.innerHTML = 'Subscribing…';
          }
        }
        klaviyoSubscribe({ company: company, listId: listId, email: email })
          .then(function (res) {
            if (!res.ok) {
              throw new Error('subscribe-failed: ' + (res.status || '') + ' ' + (res.body || ''));
            }
            // 1) Mark subscribed locally
            markSubscribed(cookieDays);
            // 2) Fire Klaviyo event for tracking (subscribe complete)
            try {
              if (window._learnq && typeof window._learnq.push === 'function') {
                window._learnq.push(['identify', { $email: email }]);
                window._learnq.push(['track', 'EPOCH Popup Subscribed', {
                  code: code,
                  percent: pct,
                  source: 'epoch-popup-w10',
                  product_handle: viewedHandle,
                  product_title: viewedTitle,
                  variant_id: viewedVariant,
                  product_image: viewedImage,
                }]);
              }
            } catch (e) {}
            // 3) Show success state
            if (card) card.classList.add('is-success');
            if (successEl) successEl.setAttribute('aria-live', 'polite');
            // 4) Auto-close after 2.8s (gives user time to read)
            setTimeout(function () { close({ skipDismiss: true }); }, 2800);
          })
          .catch(function (err) {
            if (submit) {
              submit.disabled = false;
              var span = submit.querySelector('span');
              if (span && submit.dataset.label) span.innerHTML = submit.dataset.label;
            }
            if (errorEl) {
              errorEl.textContent =
                'We couldn\'t process your subscription. Please try again, or email support@byepoch.com.';
              errorEl.classList.add('is-visible');
            }
            try { console.error('[EPOCH popup] Klaviyo subscribe failed:', err); } catch (e) {}
          });
      });
    }

    // Show on the FIRST of: a short timer, ~30% scroll depth, or exit-intent.
    // open() is idempotent, so racing triggers is safe. Earlier capture = far more emails
    // (the old single 15s timer let ad/mobile traffic bounce before ever seeing the popup).
    var effectiveDelay = isNaN(delay) ? 5000 : Math.min(delay, 5000);
    setTimeout(open, effectiveDelay);

    // Scroll-depth trigger (~30% of the page) — catches engaged readers within seconds.
    var _scFired = false;
    function _onScroll() {
      if (_scFired) return;
      var sc = window.pageYOffset || document.documentElement.scrollTop || 0;
      var h = (document.documentElement.scrollHeight - window.innerHeight) || 1;
      if (sc / h >= 0.30) { _scFired = true; window.removeEventListener('scroll', _onScroll); open(); }
    }
    window.addEventListener('scroll', _onScroll, { passive: true });

    // Exit-intent (desktop): cursor leaves toward the top of the viewport (about to bounce).
    document.addEventListener('mouseout', function (e) {
      if (!e.relatedTarget && e.clientY <= 0) open();
    });
  }

  /* ---------- Auto-fit one-line text (title, caption, fine print) ---------- */
  function fitOneLineText() {
    function fit(el, max, min) {
      if (!el) return;
      el.style.whiteSpace = 'nowrap';
      var s = max;
      el.style.fontSize = s + 'px';
      var guard = 0;
      while (el.scrollWidth > el.clientWidth + 1 && s > min && guard < 120) {
        s -= 0.5;
        el.style.fontSize = s + 'px';
        guard++;
      }
    }
    var m = window.innerWidth <= 620;
    fit(document.querySelector('.ephoc-w10__title'), m ? 34 : 33, 18);
    fit(document.querySelector('.ephoc-w10__caption'), m ? 15 : 16, 10);
    fit(document.querySelector('.ephoc-w10__fine'), m ? 12 : 11.5, 8);
  }
  window.addEventListener('resize', fitOneLineText);

  /* ---------- bootstrapping ---------- */
  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }
  ready(function () {
    // No discount is applied here: the shopper enters the code at checkout.
    if (document.body && isSubscribed()) {
      document.body.classList.add('ephoc-subscribed');
    } else {
      initPopup();
    }
  });

  /* ---------- expose for debugging ---------- */
  window.EpochPopup = {
    isSubscribed: isSubscribed,
    markSubscribed: markSubscribed,
    reset: function () {
      try {
        deleteCookie('epoch_w10');
        deleteCookie('epoch_w10_dismissed');
        localStorage.removeItem('epoch_w10');
        localStorage.removeItem('epoch_w10_at');
        sessionStorage.removeItem('epoch_w10_applied');
        sessionStorage.removeItem('epoch_w10_dismissed');
        document.body.classList.remove('ephoc-subscribed');
      } catch (e) {}
    },
  };
})();
